import(/* webpackMode: "eager" */ "/tmp/8de4f2b4a367314/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/tmp/8de4f2b4a367314/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/tmp/8de4f2b4a367314/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/tmp/8de4f2b4a367314/src/components/Header.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/tmp/8de4f2b4a367314/src/components/ui/ShareButtons.tsx");
